import React from "react";
import "./Component/Asset.css";

export function AssetUpload() {
  return (
    <div>
      <h1>[AssetUpload]</h1>
    </div>
  );
}

export function MyPage() {
  return (
    <div>
      <h1>[MyPage]</h1>
    </div>
  );
}
